"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.StyledText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const menu_label_1 = __importStar(require("./menu-label"));
exports.StyledText = (0, styled_components_1.default)(base_react_components_1.Text).withConfig({ displayName: "reports-StyledText", componentId: "reports-1kkkj2w" }) `
  color: currentColor;
  text-align: ${({ $align }) => $align !== null && $align !== void 0 ? $align : 'left'};
`;
exports.StyledButton = (0, styled_components_1.default)(base_react_components_1.Button).attrs({ variation: 'buttonLink', size: 'large' }).withConfig({ displayName: "reports-StyledButton", componentId: "reports-s29s4p" }) `
  display: grid;
  grid-template-columns: ${({ href }) => (href ? '16px 1fr 1fr 24px' : '16px 1fr 24px')};
  width: 100%;
  padding-top: 16px;
  padding-left: 8px;
  padding-bottom: 16px;
  padding-right: 24px;
  color: currentColor;
  border-radius: 0;
  box-sizing: border-box;
  position: relative;
  align-items: center;

  &:focus {
    outline: auto;
  }

  &:focus {
    outline: auto;
  }

  &::before {
    grid-column: 1;
  }

  & > ${menu_label_1.default}, & > ${menu_label_1.MenuLabelWithUnit} {
    text-align: left;
    grid-column: 2;
  }

  & > ${base_react_components_1.Chevron} {
    text-align: right;
    grid-column: 3;
  }

  &::before {
    content: ' ';
    background: ${({ $isSelected }) => ($isSelected ? base_react_components_1.theme.navBlue : 'transparent')};
    width: 5px;
    height: 24px;
    border-radius: 8px;
    margin-right: 8px;
  }

  &:hover {
    color: ${base_react_components_1.theme.neutral500};
  }

  &:hover::before {
    background: ${base_react_components_1.theme.neutral400};
  }

  &.active::before {
    background: ${base_react_components_1.theme.navBlue};
  }
`;
//# sourceMappingURL=menu.styled.js.map